module.exports = __webpack_public_path__ + "assets/img/cmd.0db20c92.jpg";